import { AppState } from '../../types/store';

export const getCurrentPage = (state: AppState) => state.pageInfo.currentPage;
export const getTotalPages = (state: AppState) => state.pageInfo.totalPages;
